import { collection, doc, getDoc, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from './firebase';

// Buscar medicamento por código de barras
export const buscarMedicamentoPorCodigo = async (codigoBarras) => {
  try {
    console.log('Buscando medicamento con código:', codigoBarras);
    
    // Limpiar el código de barras (quitar espacios, caracteres especiales)
    const cleanCode = codigoBarras.trim();
    
    // Primero intentar buscar directamente por ID (el código de barras es el ID del documento)
    const medicamentoDoc = await getDoc(doc(db, 'medicamentos', cleanCode));
    
    if (medicamentoDoc.exists()) {
      console.log('Medicamento encontrado por ID:', medicamentoDoc.data());
      return { id: medicamentoDoc.id, ...medicamentoDoc.data() };
    }
    
    // Si no se encuentra por ID, buscar por campo codigoBarras
    const q = query(
      collection(db, 'medicamentos'),
      where('codigoBarras', '==', cleanCode),
      limit(1)
    );
    
    const snapshot = await getDocs(q);
    
    if (!snapshot.empty) {
      const doc = snapshot.docs[0];
      console.log('Medicamento encontrado por campo codigoBarras:', doc.data());
      return { id: doc.id, ...doc.data() };
    }
    
    // También intentar buscar por campo 'id' (algunos documentos pueden tener el código en este campo)
    const qId = query(
      collection(db, 'medicamentos'),
      where('id', '==', cleanCode),
      limit(1)
    );
    
    const snapshotId = await getDocs(qId);
    
    if (!snapshotId.empty) {
      const doc = snapshotId.docs[0];
      console.log('Medicamento encontrado por campo id:', doc.data());
      return { id: doc.id, ...doc.data() };
    }
    
    console.log('Medicamento no encontrado en la colección medicamentos');
    return null;
  } catch (error) {
    console.error('Error buscando medicamento:', error);
    return null;
  }
};

// Buscar medicamentos por texto (nombre, sustancia, etc.)
export const buscarMedicamentosPorTexto = async (textoBusqueda) => {
  try {
    console.log('Buscando medicamentos con texto:', textoBusqueda);
    
    // Firestore no soporta búsqueda de texto completo nativamente
    // Por ahora, obtenemos todos y filtramos en cliente
    const snapshot = await getDocs(collection(db, 'medicamentos'));
    const medicamentos = [];
    const texto = textoBusqueda.toLowerCase();
    
    snapshot.forEach((doc) => {
      const medicamento = { id: doc.id, ...doc.data() };
      // Buscar en múltiples campos
      const searchableText = `${medicamento.nombre || ''} ${medicamento.sustancia || ''} ${medicamento.proveedor || ''} ${medicamento.codigoBarras || ''}`.toLowerCase();
      
      if (searchableText.includes(texto)) {
        medicamentos.push(medicamento);
      }
    });
    
    console.log(`Encontrados ${medicamentos.length} medicamentos`);
    return medicamentos;
  } catch (error) {
    console.error('Error buscando medicamentos por texto:', error);
    return [];
  }
};

// Obtener todos los medicamentos (con límite opcional)
export const obtenerMedicamentos = async (limite = 100) => {
  try {
    const q = query(collection(db, 'medicamentos'), limit(limite));
    const snapshot = await getDocs(q);
    const medicamentos = [];
    
    snapshot.forEach((doc) => {
      medicamentos.push({ id: doc.id, ...doc.data() });
    });
    
    return medicamentos;
  } catch (error) {
    console.error('Error obteniendo medicamentos:', error);
    return [];
  }
};